import { render, staticRenderFns } from "./KeyFeatures.vue?vue&type=template&id=f87b3b86&scoped=true&"
import script from "./KeyFeatures.vue?vue&type=script&lang=js&"
export * from "./KeyFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87b3b86",
  null
  
)

export default component.exports